import { render, staticRenderFns } from "./ClientSection.vue?vue&type=template&id=04b2e7aa&scoped=true"
import script from "./ClientSection.vue?vue&type=script&lang=js"
export * from "./ClientSection.vue?vue&type=script&lang=js"
import style0 from "./ClientSection.vue?vue&type=style&index=0&id=04b2e7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b2e7aa",
  null
  
)

export default component.exports